import { useRouter } from 'next/navigation'
import type { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import useEnumsData from 'src/hooks/data/use-enums-data'
import configuration from '~/configuration'
import { TypographyText } from '~/core/ui/Text'

import type { INotification, INotificationJob } from '~/lib/features/notifications/types'

import NotificationItemLayout from './NotificationItemLayout'

const UserUpdateJobStatus: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const { i18n, t } = useTranslation()
  const router = useRouter()
  const jobStatus = useEnumsData({
    enumType: 'JobStatus',
    locale: i18n.language
  })
  const propertiesRelated = notification?.payload as INotificationJob

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.user}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <TypographyText
          className="cursor-pointer text-sm text-gray-700"
          onClick={() => {
            onClick && onClick()
            router.push(configuration.path.jobs.detail(propertiesRelated.jobId))
          }}>
          <Trans
            i18nKey="activity:notification:userUpdateJobStatus"
            values={{
              userName: notification?.user?.fullName,
              jobTitle: propertiesRelated?.jobTitle,
              oldJobStatus: t(`label:jobStatus:${propertiesRelated?.fromStatus}`),
              newJobStatus: t(`label:jobStatus:${propertiesRelated?.toStatus}`)
            }}>
            <span className="font-medium text-gray-900" />
          </Trans>
          {time}
        </TypographyText>
      )}
    </NotificationItemLayout>
  )
}

export default UserUpdateJobStatus
